/**
 * @file 支払開始月(初回支払月)の判定
 *
 * 支払開始月は「申込月 + N ヶ月」で決まる。この N を決めるルールが2種類ある。
 *
 *  ┌────────────┬──────────────┬────────┬──────────────────────────┐
 *  │ 加盟店ルール │ 各支払方法の設定 │ 申込日  │ 支払開始月                 │
 *  ├────────────┼──────────────┼────────┼──────────────────────────┤
 *  │ 現行         │ OFF            │ 全日    │ 翌々月固定 (+2)            │
 *  │ 現行         │ ON             │ 〜10日  │ 翌月 (+1)                 │
 *  │ 現行         │ ON             │ 11日〜  │ 翌々月 (+2)               │
 *  │ 新           │ OFF            │ 全日    │ 翌月固定 (+1)              │
 *  │ 新           │ ON             │ 〜10日  │ 翌月 (+1)                 │
 *  │ 新           │ ON             │ 11日〜  │ 翌々月 (+2)               │
 *  └────────────┴──────────────┴────────┴──────────────────────────┘
 *
 * 「各支払方法の設定」は加盟店契約編集の以下のスイッチを指す。
 *   - 分割・ボ併 支払期間開始     : setting_split_bonus_start_period
 *   - ボ1・ボ2 支払月            : setting_bonus_start_period
 *   - マンスリークリア 支払い月    : setting_monthly_start_period
 *
 * 「加盟店ルール」の参照元は画面によって異なる。
 *   - 申込画面        : 加盟店の現在設定 (store_options 経由の use_new_payment_start_rule)
 *   - 契約修正・商品変更 : 契約に焼き込まれた値 (contracts.use_new_payment_start_rule)
 *     ※ 加盟店設定を後から変更しても既存契約の支払開始月を変えないため
 */

/** 支払開始月の区切り日。この日までの申込は翌月、翌日以降は翌々月 */
export const PAYMENT_START_BORDER_DAY = 10

/** 支払開始月の加算月 : 翌月 */
export const ADD_MONTH_NEXT = 1

/** 支払開始月の加算月 : 翌々月 */
export const ADD_MONTH_AFTER_NEXT = 2

/**
 * 支払開始月の加算月(1 = 翌月 / 2 = 翌々月)を返す
 *
 * @param {object} appDate moment 申込日
 * @param {bool} isBorderRuleEnabled 該当支払方法の設定スイッチ(ON なら区切り日判定を行う)
 * @param {bool} useNewRule 加盟店の支払開始月ルール(true: 新 = 翌月基準 / false: 現行 = 翌々月基準)
 * @return {number} 1 または 2
 */
export const startPeriodAddMonth = (appDate, isBorderRuleEnabled, useNewRule) => {
  if (isBorderRuleEnabled) {
    // スイッチONの挙動は新旧ルールで変わらない(現行踏襲)
    return appDate.date() <= PAYMENT_START_BORDER_DAY ? ADD_MONTH_NEXT : ADD_MONTH_AFTER_NEXT
  }

  // スイッチOFFの意味が新ルールで「翌々月固定」から「翌月固定」に変わる
  return useNewRule ? ADD_MONTH_NEXT : ADD_MONTH_AFTER_NEXT
}

/**
 * 加盟店の支払開始月ルールを安全に取り出す
 *
 * 未取得・未設定の場合は現行ルール(false)として扱う。
 *
 * @param {object} source store_options の1件 または contracts の1件
 * @return {bool}
 */
export const useNewPaymentStartRule = (source) => Boolean(source && source.use_new_payment_start_rule)
